import React from 'react'
import TableCell from '@material-ui/core/TableCell';

export default function HeaderCol(props) {
    return (
        <TableCell style={{padding: "4px", textAlign: "center", backgroundColor: props.shaded ? "#e8e8e8" : undefined}} colSpan={props.me === undefined || !props.me.accessProfile.showRevenue ? 1 : 2}>
            <strong>{props.children}</strong>
        </TableCell>
    )
}